import { usePopperTooltip } from "react-popper-tooltip";

import { FaInfoCircle } from "../Icon/fa/FaInfoCircle";

import "react-popper-tooltip/dist/styles.css";

export default function Tooltip({ tooltipText }) {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip();

  return (
    <>
      <button
        type="button"
        ref={setTriggerRef}
        className=" relative ml-2.5 mt-2 inline flex-none cursor-pointer"
      >
        <FaInfoCircle className=" text-base text-bbc-neutral-600" />
      </button>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            style: { width: "300px" },
            className: "tooltip-container",
          })}
        >
          <div
            {...getArrowProps({
              className: "tooltip-arrow",
            })}
          />
          {tooltipText}
        </div>
      )}
    </>
  );
}
